import { render, staticRenderFns } from "./multiple-select.vue?vue&type=template&id=f72c2418"
import script from "./multiple-select.vue?vue&type=script&lang=js"
export * from "./multiple-select.vue?vue&type=script&lang=js"
import style0 from "./multiple-select.vue?vue&type=style&index=0&id=f72c2418&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports